import React, { useEffect, useState } from 'react';
import Chart from 'chart.js/auto';


const Message = ({message}) =>{
    useEffect(()=>{
        const ctx = document.getElementById('messagechart');
        
        const myChart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: message.label,
                datasets: [{
                    label: '# of Votes',
                    data: message.val,
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(255, 159, 64, 0.2)'
                    ],
                    borderColor: [
                        'rgba(255, 99, 132, 1)',
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(75, 192, 192, 1)',
                        'rgba(153, 102, 255, 1)',
                        'rgba(255, 159, 64, 1)'
                    ],
                    borderWidth: 1
                }]
            },
            options: {
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            }
        });
    },[])
    
    return (
        <canvas id="messagechart"  height="200"></canvas>
    )
}
export default Message